import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import styles from './LoadingBlock.module.scss';

const cx = classnames.bind(styles);

const LoadingBlock = ({className, theme, ...props}) => (<span className={cx('loading-animation', theme, className)} {...props} />)

LoadingBlock.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['default', 'semi-rounded', 'rounded'])
}

LoadingBlock.defaultProps = {
  className: '',
  theme: 'default'
}

export default LoadingBlock;
